export const getLearningStyleLabel = (style: string) => {
    const styles = {
        visual: "Visual - Student learns best through images, diagrams, and charts",
        auditory: "Auditory - Student learns best through listening and discussion",
        reading: "Reading/Writing - Student learns best through text and writing",
        kinesthetic: "Kinesthetic - Student learns best through hands-on activities",
    };
    return styles[style as keyof typeof styles] || style;
};

export const getLearningPaceLabel = (pace: string) => {
    const paces = {
        slow: "Slow - Student needs time to process information",
        steady: "Steady - Student likes a consistent, moderate pace",
        fast: "Fast - Student can handle quick progression",
        "self-paced": "Self-paced - Student prefers to control the speed",
    };
    return paces[pace as keyof typeof paces] || pace;
}; 